import * as defaultsDeep from 'lodash.defaultsdeep';
import { environmentDefaults } from './environment-defaults';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.local.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

const override = {
  baseUrl: 'http://localhost:8080',
  hostname: 'localhost',
  onyxCommonDataUrl: 'http://localhost:8080/ocd/api',

  production: false,

  logServices: {
    consoleLogSubscriber: {
      logLevel: 4
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  },

  googleAnalytics: {
    id: 'UA-96125697-1',
    loadType: 'auto'
  },

  allowApiDocs: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.local.ts